//? ============================================ Constants ============================================

export const USER_AUTHENTICATION_URL = '/api/login'
export const USER_LOGOUT_URL = '/api/logout'
export const USER_REGISTRATION_URL = '/api/user/register'
export const USER_CHANGE_PASSWORD_URL = '/api/user/change-password'
export const USER_PROFILE_URL = '/api/profile'
export const USER_DELETE_URL = '/api/user/delete'
export const USER_DATA_FETCH_URL = '/api/user'
export const USER_POINTS_TRANS_URL = '/api/transaction'
export const USER_ACTIVE_REWARDS_DATA_URL = '/api/reward'
export const USER_REWARD_REDEEMED_HISTORY_URL = '/api/reward/redeemed'
export const USER_REWARD_QRCODE_URL = '/api/reward/qrcode/batch'
export const USER_DECRYPT_REWARD_QRCODE_URL = '/api/reward/decrypt-data'
export const USER_SEND_EMAIL_OTP_URL = '/api/user/send-email/otp'
export const USER_VERIFY_EMAIL_URL = '/api/user/verify-email'
export const USER_CHECK_EMAIL_EXIST_URL = '/api/forgot-password/check-email'
export const USER_UPDATE_EXPIRED_TRANSACTION_URL = '/api/transaction/check-expired-points-transactions'
export const USER_UPDATE_STAMP_EXPIRED_TRANSACTION_URL = '/api/transaction/check-expired-stamps-transactions'
export const USER_FORGET_PASSWORD_SEND_EMAIL_OTP_URL = '/api/forget-password/send-otp-email'
export const USER_FORGET_PASSWORD_VERIFY_OTP_URL = '/api/forget-password/verify-otp'
export const USER_RESET_PASSWORD_URL = '/api/forget-password/reset'
export const USER_STAMP_REWARD_DATA_URL = '/api/reward/stamp-reward'
export const USER_STAMP_TRANS_URL = '/api/transaction/stamp'
export const USER_POINTS_EXPIRY_SOON_URL = '/api/transaction/points-expiry-soon'


export const ADMIN_AUTHENTICATION_URL = '/api/admin/login'
export const ADMIN_LOGOUT_URL = '/api/logout'
export const ADMIN_REGISTRATION_URL = '/api/admin/register'
export const ADMIN_CHANGE_PASSWORD_URL = '/api/admin/change-password'
export const ADMIN_PROFILE_URL = '/api/admin/profile'
export const ADMIN_USERS_DATA_FETCH_URL = '/api/admin/users'
export const ADMIN_ADD_POINT_USER_URL = '/api/transaction/add-point'
export const ADMIN_ADD_STAMP_USER_URL = '/api/transaction/add-stamp'
export const ADMIN_CREATE_REWARD_URL = '/api/reward/create'
export const ADMIN_UPDATE_REWARD_URL = '/api/reward/update'
export const ADMIN_ALL_REWARDS_DATA_URL = '/api/reward/all'
export const ADMIN_USERS_REWARDS_DATA_FETCH_URL = '/api/reward/users'
export const ADMIN_REDEEM_USER_REWARD_URL = '/api/reward/redeem-reward'
export const ADMIN_UPDATE_USER_URL = '/api/admin/update-admin'
export const ADMIN_ALL_DASHBOARD_STATS_URL = '/api/admin/dashboard-stats'
export const ADMIN_FETCH_TODAYS_EARNINGS_URL = '/api/transaction/todays-earnings'
export const ADMIN_FETCH_TODAYS_STAMPS_EARNINGS_URL = '/api/transaction/todays-stamps-earnings'
export const ADMIN_REDEEM_USER_STAMP_REWARD_URL = '/api/reward/redeem-stamp'
export const ADMIN_VALIDATE_REWARD_TYPE_URL = '/api/reward/validate-reward-type'

// export const PROFILE_IMAGE_DIR_PATH = process.env.REACT_APP_API_BASE_URL + '/UserProfileImages/'
// export const REWARD_IMAGE_DIR_PATH = process.env.REACT_APP_API_BASE_URL + '/RewardImages/'
